// page.tsx
"use client";

import { useState, Suspense, lazy } from "react";
import LockScreen from "../../Components/Lockscreen";
import "./Area51.css";

import { Area51Mail } from "./Area51Assets/Area51MailContent";
import { Area51NoteContent } from "./Area51Assets/Area51NoteContent";
import { Area51MessageContent } from "./Area51Assets/Area51MessagesContent";
import { Area51CallContent } from "./Area51Assets/Area51CallContent";
import { Chat_content } from "../../Components/MessageApp/MessagesInterfaces";
import CallApp from "../../Components/CallApp/CallApp";
import { Area51PhotoContent } from "./Area51Assets/Area51PhotoContent";
import InternetBanner from "./Area51Assets/Area51Pictures/Interner-Logo-01.webp";
import InternetLogo from "./Area51Assets/Area51Pictures/Interner-Logo-02.webp";
import InternetBody from "./Area51Assets/Area51Pictures/Moogle.png";
import HomeIcon from "../../Components/Icons/HomeIcon";
import mapImage from "./Area51Assets/Area51MapContent/Map.jpg";
import { recentSearches } from "./Area51Assets/Area51MapContent/Area51MapContent";

const Messages = lazy(() => import("../../Components/MessageApp/Messages"));
const Photos = lazy(() => import("../../Components/PhotosApp/Photos"));
const AppsMenu = lazy(() => import("../../Components/AppsMenu/AppsMenuArea51"));
const NotesApp = lazy(() => import("../../Components/NotesApp/NotesApp"));
const InternetApp = lazy(
  () => import("../../Components/InternetApps/Area51InternetApp/InternetApp")
);
const MailApp = lazy(() => import("../../Components/MailApp/MailApp"));
const MapsApp = lazy(() => import("../../Components/MapApp/MapsStatic"));

function Area51() {
  const [isLocked, setIsLocked] = useState(true);
  const [activeApp, setActiveApp] = useState("appsmenu");
  const [messages, setMessages] = useState(Area51MessageContent);
  const [messageNotifications, setMessageNotifications] = useState(0);

  const unlock = () => {
    setIsLocked(false);
  };

  const handleStateChange = (chat: Chat_content) => {
    const chatIndex = messages.findIndex(
      (message: any) => message.name === chat.name
    );
    const previousMessage = messages[chatIndex];
    if (previousMessage && !previousMessage.read) {
      const newMessages = [...messages];
      newMessages[chatIndex] = {
        ...newMessages[chatIndex],
        read: true,
      };
      setMessages(newMessages);
      setMessageNotifications(messageNotifications - 1);
    }
  };

  const renderApp = () => {
    switch (activeApp) {
      case "messages":
        return (
          <Messages
            influencerMessageContent={messages}
            theGram={false}
            handleStateChange={handleStateChange}
          />
        );
      case "phone":
        return <CallApp callContent={Area51CallContent} />;
      case "photos":
        return <Photos albums={Area51PhotoContent} />;
      case "notes":
        return <NotesApp noteContent={Area51NoteContent} />;
      case "appsmenu":
        return (
          <AppsMenu
            isLocked={isLocked}
            setActiveApp={setActiveApp}
            messageNotifications={messageNotifications}
          />
        );
      // case "tweeter":
      // return <TweeterApp tweeterContent={Area51TweetContent} />;
      case "mail":
        return <MailApp emails={Area51Mail} />;
      case "thegram":
        return; // <TheGramApp content={Area51TheGramContent} notifications={0} />
      case "maps":
        return <MapsApp mapImage={mapImage} recentSearches={recentSearches} />;

      case "internet":
        return (
          <InternetApp
            headerImage={InternetBanner}
            logoIcon={InternetLogo}
            bodyImage={InternetBody}
            website=""
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className="Mystery">
      <div className="phone-wrapper">
        <div className={`Area51screen ${activeApp}`}>
          {isLocked ? (
            <div
              className={`lockscreen-container ${
                isLocked ? "visible" : "hidden"
              }`}
            >
              <LockScreen unlock={unlock} password="953479" />
            </div>
          ) : null}

          <Suspense
            fallback={
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                }}
              >
                Loading...
              </div>
            }
          >
            {renderApp()}
          </Suspense>
          <div className="home-button-container">
            <HomeIcon onClick={() => setActiveApp("appsmenu")} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Area51;
